import 'axios';
import { transformCustomerAddressRequest, transformCustomerAddress } from '../transformers/customer/index.js';
import { transformTotals } from '../transformers/cartCheckout/index.js';
import { transformOrder } from '../transformers/order/index.js';

const transformSalesCheckoutGiftOptionsResponse = ({ sender , recipient , message , wrapping_id , livstick_video  })=>({
        sender,
        recipient,
        message,
        wrapId: wrapping_id,
        ...livstick_video ? {
            livStickVideo: livstick_video
        } : {}
    });
const transformSalesCheckoutMeTotalsResponse = (data)=>transformTotals(data);
const transformSalesCheckoutPaymentMethodsResponse = ({ method  })=>method;
const transformSalesCheckoutShippingMethodsResponse = ({ method_code , method_title , carrier_code , carrier_title , price_incl_tax  })=>({
        methodCode: method_code,
        methodTitle: method_title,
        carrierCode: carrier_code,
        carrierTitle: carrier_title,
        price: price_incl_tax
    });
const transformPostSalesCheckoutShippingMethodsResponse = (shippingMethods)=>shippingMethods ? shippingMethods.map((shippingMethod)=>transformSalesCheckoutShippingMethodsResponse(shippingMethod)) : [];
const transformSalesGiftWrapResponse = (data)=>data.map(({ id , base_price , design , image_url , image_name  })=>({
            id: parseInt(id),
            label: design,
            image: image_url,
            imageTitle: image_name,
            price: base_price
        }));
const transformSalesCheckoutAddressRequest = ({ email , pickupId , regionId , regionText , postcode , telephone , ...address } = {})=>({
        ...transformCustomerAddressRequest(address),
        id: undefined,
        ...pickupId ? {
            selected_store_id: pickupId
        } : {},
        postcode: postcode ?? '',
        region: undefined,
        ...regionId ? {
            region_id: regionId
        } : {
            region: regionText?.toString() ?? ''
        },
        email,
        telephone: telephone ?? ''
    });
const transformSalesCheckoutShippingRequest = ({ shippingAddress , billingAddress , shippingCarrierCode , shippingMethodCode , externalPickUpServicesIds =[]  })=>({
        billing_address: Object.keys(billingAddress || {}).length > 0 ? transformSalesCheckoutAddressRequest(billingAddress) : {},
        shipping_address: transformSalesCheckoutAddressRequest({
            ...shippingAddress,
            ...(shippingCarrierCode === 'pickupinstore' || externalPickUpServicesIds.includes(shippingCarrierCode)) && !shippingAddress.pickupId ? {
                pickupId: -1
            } : {}
        }),
        shipping_carrier_code: shippingCarrierCode,
        shipping_method_code: shippingMethodCode
    });
const transformPaymentMethod = (paymentMethod, additionalConfigs = [])=>{
    const additionalConfig = additionalConfigs.find(({ code  })=>new RegExp(`^${code}_`).test(paymentMethod.code));
    return {
        ...paymentMethod,
        additionalConfig: additionalConfig?.informations ?? null
    };
};
const transformSalesCheckoutShippingResponse = ({ payment_methods , extension_attributes , totals  })=>{
    return {
        paymentMethods: payment_methods.map((paymentMethod)=>transformPaymentMethod(paymentMethod, extension_attributes?.payments_additional_information)),
        totals: transformTotals(totals)
    };
};
const transformFiscalInformation = ({ request_invoice , company_name , destination_code , national_identification_number , pec_email , vat_number , registered_office  } = {})=>({
        request_invoice,
        company_name,
        destination_code,
        national_identification_number: national_identification_number?.trim(),
        pec_email,
        vat_number,
        registered_office
    });
const transformPaymentInformations = ({ origin , returnUrl , authorizationToken , brandCode , ...rest } = {})=>({
        origin,
        returnUrl,
        brand_code: brandCode,
        authorization_token: authorizationToken,
        ...rest
    });
const transformSalesCheckoutPlaceOrderRequest = ({ fiscalInformation , paymentInformations , paymentMethod  })=>({
        fiscal_information: transformFiscalInformation(fiscalInformation),
        payment_informations: transformPaymentInformations(paymentInformations),
        payment_method: paymentMethod
    });
const transformSalesCheckoutPlaceOrderResponse = ({ order , payment  })=>({
        order: transformOrder(order),
        payment
    });
const transformSalesCheckoutBillingAddressRequest = ({ billingAddress: { postcode , regionId , regionText , telephone , email , ...billingAddress }  })=>({
        ...transformCustomerAddressRequest(billingAddress),
        id: undefined,
        postcode: postcode ?? '',
        telephone: telephone ?? '',
        region: undefined,
        ...regionId ? {
            region_id: regionId
        } : {
            region: regionText?.toString() ?? ''
        },
        ...{
            email
        }
    });
const transformSalesCheckoutCouponResponse = (data)=>{
    if (typeof data === 'object' && !data.length) {
        return null;
    }
    return data;
};
const transformSalesPaymentCheckoutDetailsResponse = ({ billing_address , shipping_address , payment_information  })=>({
        email: billing_address?.email ?? shipping_address?.email,
        billingAddress: transformCustomerAddress(billing_address),
        shippingAddress: transformCustomerAddress(shipping_address),
        payment: payment_information
    });
const transformSalesPaymentInitResponse = (data)=>data;
const transformSalesCheckoutVatValidationRequest = ({ vatNumber , countryCode  })=>({
        vat_number: vatNumber,
        country_code: countryCode
    });
const transformSalesCheckoutVatValidationResponse = ({ valid , message  } = {})=>({
        valid,
        message: message ?? ''
    });

export { transformPaymentMethod, transformPostSalesCheckoutShippingMethodsResponse, transformSalesCheckoutBillingAddressRequest, transformSalesCheckoutCouponResponse, transformSalesCheckoutGiftOptionsResponse, transformSalesCheckoutMeTotalsResponse, transformSalesCheckoutPaymentMethodsResponse, transformSalesCheckoutPlaceOrderRequest, transformSalesCheckoutPlaceOrderResponse, transformSalesCheckoutShippingMethodsResponse, transformSalesCheckoutShippingRequest, transformSalesCheckoutShippingResponse, transformSalesCheckoutVatValidationRequest, transformSalesCheckoutVatValidationResponse, transformSalesGiftWrapResponse, transformSalesPaymentCheckoutDetailsResponse, transformSalesPaymentInitResponse };
